import { createStyles, fade, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette } from '../../../../theme';

const useStyles = (scrolled) =>
  makeStyles((theme: Theme) => {
    return createStyles({
      wrapper: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('xl')]: {
          flexDirection: 'row',
        },
      },
      backgroundBox: {
        width: '100vw',
        position: 'absolute',
        background: fade(colorsPalette.blueDark, 0.85),
        height: 0,
        left: 0,
        top: scrolled ? 80 : 100,
        bottom: 0,
        right: 0,
        borderTop: `1px solid ${fade(colorsPalette.white, 0.2)}`,
        transition: 'all .5s ease-in-out',
        opacity: 0,
        display: 'none',
        [theme.breakpoints.up('xl')]: {
          display: 'block',
        },
      },
      headerBackgroundBox: {
        width: '100vw',
        position: 'absolute',
        background: 'transparent',
        height: scrolled ? 80 : 100,
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        transition: 'all .5s ease-in-out',
        opacity: 0,
        display: 'none',
        [theme.breakpoints.up('xl')]: {
          display: 'block',
        },
      },
      menuItem: {
        borderBottom: `1px solid ${fade(colorsPalette.white, 0.15)}`,
        '&$lastMenuItem': {
          borderBottom: 'none',
        },
        [theme.breakpoints.up('xl')]: {
          borderBottom: 'none',
          '&.hasSubItems:hover ~ $backgroundBox': {
            height: '100vh',
            opacity: 1,
          },
          '&.hasSubItems:hover ~ $headerBackgroundBox': {
            opacity: 1,
            background: scrolled ? 'transparent' : fade(colorsPalette.blueDark, 0.85),
          },
        },
      },
      lastMenuItem: {},
    });
  });

export default useStyles;
